import React from 'react';

export const IconCutter: React.FC<React.SVGAttributes<SVGElement>> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 266.7">
    <path fill="#dadada" d="M1333 233V33h267l-67 200h-200z" />
    <path fill="#b2b2b2" d="M1600 33h-267v12h263l4-12z" />
    <path
      d="M1385 267H200V0h1185c7 0 16 5 19 12l57 110c3 6 3 17 0 23l-57 110c-3 6-12 12-19 12z"
      fill="#e94e1b"
    />
    <path fill="#be1622" d="M333 67h834v133H333z" />
    <path
      d="M305 200a29 29 0 018-20 29 29 0 0120-8 29 29 0 0120 8 29 29 0 019 20 29 29 0 01-9 20 29 29 0 01-20 8 29 29 0 01-20-8 29 29 0 01-8-20zM333 105a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zM305 67a29 29 0 018-20 29 29 0 0120-9 29 29 0 0120 9 29 29 0 019 20 29 29 0 01-9 20 29 29 0 01-20 8 29 29 0 01-20-8 29 29 0 01-8-20zM409 39a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zM1138 67a29 29 0 019-20 28 28 0 0120-9 29 29 0 0120 9 29 29 0 018 20 29 29 0 01-8 20 29 29 0 01-20 8 29 29 0 01-20-8 29 29 0 01-9-20zM1167 105a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zM1138 200a29 29 0 019-20 28 28 0 0120-8 29 29 0 0120 8 29 29 0 018 20 29 29 0 01-8 20 29 29 0 01-20 8 29 29 0 01-20-8 29 29 0 01-9-20zM407 172a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28zm76 0a28 28 0 0128 28 28 28 0 01-28 28 28 28 0 01-28-28 28 28 0 0128-28z"
      fill="#be1622"
    />
    <rect
      x="533.3"
      y="66.7"
      width="733.3"
      height="133.3"
      rx="33.3"
      ry="33.3"
      fill="#b2b2b2"
    />
    <rect
      x="400"
      y="66.7"
      width="200"
      height="133.3"
      rx="33.3"
      ry="33.3"
      fill="#e94e1b"
    />
    <path
      d="M396 166V99a37 37 0 0137-36h133a37 37 0 0137 36v67a37 37 0 01-37 37H433a37 37 0 01-37-37zm200-67a30 30 0 00-30-30H433a30 30 0 00-30 30v67a30 30 0 0030 30h133a30 30 0 0030-30V99z"
      fill="#be1622"
    />
    <circle cx="700" cy="133.3" r="33.3" fill="#706f6f" />
    <path
      d="M333 67h-66c-34 0-34 33-34 33v67c0 33 34 33 34 33h66V67z"
      fill="#be1622"
    />
    <path d="M200 0H79C-68 0-1 267 200 267V0z" fill="#706f6f" />
    <path d="M200 44h-80c-98 0-54 178 80 178V44z" fill="#575756" />
    <path fill="#be1622" d="M467 67h13v133h-13z" />
  </svg>
);
